var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarCapital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_480_7274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6C12.843 6 11.5 6.895 11.5 8C11.5 9.105 12.843 10 14.5 10C16.157 10 17.5 10.895 17.5 12C17.5 13.105 16.157 14 14.5 14M14.5 6V14M14.5 6C15.61 6 16.58 6.402 17.099 7M14.5 6V5M14.5 14V15M14.5 14C13.39 14 12.42 13.598 11.901 13M23.5 10C23.5 11.1819 23.2672 12.3522 22.8149 13.4442C22.3626 14.5361 21.6997 15.5282 20.864 16.364C20.0282 17.1997 19.0361 17.8626 17.9442 18.3149C16.8522 18.7672 15.6819 19 14.5 19C13.3181 19 12.1478 18.7672 11.0558 18.3149C9.96392 17.8626 8.97177 17.1997 8.13604 16.364C7.30031 15.5282 6.63738 14.5361 6.18508 13.4442C5.73279 12.3522 5.5 11.1819 5.5 10C5.5 7.61305 6.44821 5.32387 8.13604 3.63604C9.82387 1.94821 12.1131 1 14.5 1C16.8869 1 19.1761 1.94821 20.864 3.63604C22.5518 5.32387 23.5 7.61305 23.5 10Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.1272C18.0414 19.0144 17.4395 19.8156 16.725 20.5C15.1084 22.0486 12.9153 23 10.5 23C5.52944 23 1.5 18.9706 1.5 14C1.5 11.5847 2.45145 9.39159 4 7.77506C4.71704 7.02654 5.5621 6.40164 6.5 5.93555",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_480_7274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCapital);
export default __webpack_public_path__ + "static/media/dollarCapital.2b2696bded762e1a12a3da591a78a091.svg";
export { ForwardRef as ReactComponent };